import React, { useState, useEffect } from 'react';
import { Box, Grid, Paper, Typography, Tooltip } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import { useNavigate } from 'react-router-dom';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { useStyles } from './styles';
import routes from '../../../Utils/routes';
import { useMediaQuery, useTheme, Button } from '@mui/material';
import DefaulImage from '../../../Assets/DefaultProfile.png';
const ITEMS_PER_PAGE = 20;
const MentorshipContainer: React.FunctionComponent<any> = ({ cardData, type, showAll }) => {
  console.log(cardData, "cardDatacardDatacardData");

  const classes = useStyles();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [paginatedData, setPaginatedData] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const visibleData = isMobile && !showAll ? paginatedData.slice(0, 2) : paginatedData;
  console.log(visibleData, 'visibleDatavisibleDatavisibleDatavisibleData');

  useEffect(() => {
    if (cardData?.length) {
      const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
      const endIndex = startIndex + ITEMS_PER_PAGE;
      setPaginatedData(cardData.slice(startIndex, endIndex));
      setTotalPages(Math.ceil(cardData.length / ITEMS_PER_PAGE));
    } else {
      setPaginatedData([]);
      setTotalPages(1);
    }
  }, [cardData, currentPage]);

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  console.log(paginatedData, 'cardDatassssss');

  return (
    <div className={classes.networkCardContainer}>
      <Box width="100%">
        <Paper className={classes.cardHolder}>
          {paginatedData.length === 0 ? (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" py={8} height={'50vh'}>
              <Typography variant="body2" color="textSecondary">
                You have not {type} yet
              </Typography>
              <Typography variant="h5" textAlign={"center"} color="textSecondary" gutterBottom>
                Get started by connecting with people in your network
              </Typography>
            </Box>
          ) : (
            <Box
              // className="scrollbar-cusgray"
              sx={{
                flex: 1,
                // maxHeight: 'calc(60vh - 10px)',
                // minHeight: '200px',
                // overflowY: 'auto',
                marginTop: '10px',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Grid
                container
                spacing={1}
                sx={{
                  height: '100%', // KEY FIX: Make container take full height
                  alignContent: 'flex-start' // Align items to start
                }}
              >
                {isMobile && !showAll && (
                  <Grid
                    item
                    xs={12}
                    sx={{
                      marginBottom: 1,
                      textAlign: 'center',
                    }}
                  >
                  </Grid>
                )}
                {visibleData.map((data: any, index: number) => (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={3}
                    lg={3}
                    xl={3}
                    key={data.Id || index}
                    sx={{
                      display: 'flex', // KEY FIX: Make grid item flex
                      // height: 'auto', // Let it grow naturally
                      minHeight: '260px' // Set minimum height for consistency
                    }}
                  >
                    <div
                      className={classes.networkCard}
                      onClick={() => {
                        navigate(`${routes.mentorshipDetailview}/${data.contactDetails?.id}`, {
                          state: { data: cardData, breadCrumbs: data?.contactDetails?.name },
                        });
                      }}
                      style={{
                        width: '100%', // KEY FIX: Take full width
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%' // KEY FIX: Take full height of grid item
                      }}
                    >
                      {((!data?.isMentor && data?.mentorConnectionRequestSent) || (!data?.isMentee && data?.menteeConnectionRequestSent)) && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 0,
                            right: 0,
                            backgroundColor: '#6D6F74',
                            color: '#fff',
                            fontSize: 11,
                            fontWeight: 500,
                            px: 1.25,
                            py: 0.5,
                            borderBottomLeftRadius: '8px',
                            borderTopRightRadius: '8px',
                          }}
                        >
                          Request sent
                        </Box>
                      )}


                      {/* KEY FIX: Make this container flex and grow */}
                      <Box
                        sx={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          mt: 2,
                          px: 1
                        }}
                      >
                        {/* Profile Picture with Online Dot */}
                        <Box position="relative" width={100} height={100} mb={1}>
                          <img
                            src={
                              data.contactDetails?.profilePicURL
                                ? data.contactDetails?.profilePicURL
                                : DefaulImage
                            }
                            alt="featured img"
                            className={classes.cardImage}
                            style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                          />
                          {/* Online Indicator Dot */}
                          {data?.contactDetails?.isOnline && (
                            <Box
                              position="absolute"
                              top={80}
                              right={5}
                              width={14}
                              height={14}
                              borderRadius="50%"
                              bgcolor="#4CAF50"
                              border="2px solid white"
                            />
                          )}
                        </Box>

                        {/* Content area */}
                        <Box
                          sx={{
                            textAlign: 'center',
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            width: '100%'
                          }}
                        >
                          <Box>
                            <Tooltip title={data?.contactDetails?.name || ''}>
                              <Typography className={classes.cardHeader}>
                                {data?.contactDetails?.name?.length > 15 ? `${data?.contactDetails?.name.slice(0, 15)}...` : data?.contactDetails?.name}
                              </Typography>
                            </Tooltip>
                            <Typography className={classes.cardActionContainerTypo}>
                              {data?.contactDetails?.designation ? data?.contactDetails?.designation : data?.contactDetails?.employmentDetails?.[0]?.Title__c || '-'}
                            </Typography>
                          </Box>

                          <Typography
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              margin: '20px 20px',
                              fontSize: '14px',
                              color: '#585A64',
                              marginTop: 'auto' // Push to bottom
                            }}
                          >
                            <LocationOnOutlinedIcon style={{ fontSize: 18, marginRight: 4 }} />
                            {/* {data?.contactDetails?.city || 'Pune'} */}
                            {data?.contactDetails?.country ? ` ${data?.contactDetails?.country}` : ` India`}
                          </Typography>
                        </Box>
                      </Box>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </Box>
          )}

          {/* Pagination: Only show if more than 1 page, always at the bottom, outside scrollable area */}
          {totalPages > 1 && (
            <Box display="flex" justifyContent="center" mt={2}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded"
                siblingCount={1}
                boundaryCount={1}
                sx={{
                  '& .MuiPaginationItem-root': {
                    borderRadius: '8px',
                    fontWeight: 400,
                    color: '#000',
                    border: '1px solid #E0E0E0',
                    '&:hover': {
                      backgroundColor: '#F5F5F5',
                    },
                  },
                  '& .MuiPaginationItem-page.Mui-selected': {
                    backgroundColor: '#123A6F',
                    color: '#fff',
                  },
                }}
              />
            </Box>
          )}
        </Paper>
      </Box>
    </div>
  );
};

export default MentorshipContainer;
